import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class CustomerDebtAlertResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                'debt_alert': {
                    'code': 'long_overdue_debt',
                    'worst_tier': {'code': '22_to_30', 'label': '+21 a 30'}
                }
            },
            errors: []
        }
    }

    debtAlert() {
        const debtAlert = this.content().debt_alert;
        if (!debtAlert) {
            return null;
        }
        const worstTier = debtAlert.worst_tier;
        return {
            code: debtAlert.code,
            worstTier: worstTier ? {code: worstTier.code, label: worstTier.label} : null,
        };
    }
}
